var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      directives: [
        { name: "drag", rawName: "v-drag" },
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.laoding,
          expression: "laoding",
        },
      ],
      attrs: {
        visible: _vm.dialogVisible,
        width: "800px",
        title: !_vm.rowData?.id ? "新增" : "修改",
        "close-on-click-modal": false,
        "close-on-press-escape": false,
        "before-close": _vm.cancel,
        top: "0",
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _c(
        "div",
        { staticClass: "content" },
        [
          _c(
            "el-form",
            {
              ref: "form",
              attrs: {
                "label-position": "top",
                model: _vm.form,
                rules: _vm.rules,
              },
            },
            [
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "单号", prop: "serviceNo" } },
                        [
                          _c("el-input", {
                            staticStyle: { width: "320px" },
                            attrs: { disabled: true, placeholder: "请输入" },
                            model: {
                              value: _vm.form.serviceNo,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "serviceNo", $$v)
                              },
                              expression: "form.serviceNo",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticStyle: { width: "320px" },
                          attrs: { label: "客户", prop: "companyId" },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "320px" },
                              attrs: {
                                placeholder: "请选择",
                                filterable: "",
                                clearable: "",
                              },
                              model: {
                                value: _vm.form.companyId,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "companyId", $$v)
                                },
                                expression: "form.companyId",
                              },
                            },
                            _vm._l(_vm.companyDrapdown, function (item) {
                              return _c("el-option", {
                                key: item.value,
                                attrs: { label: item.label, value: item.value },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticStyle: { width: "320px" },
                          attrs: { label: "供应商", prop: "supplierId" },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "320px" },
                              attrs: {
                                placeholder: "请选择",
                                filterable: "",
                                clearable: "",
                                multiple: "",
                              },
                              model: {
                                value: _vm.form.supplierId,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "supplierId", $$v)
                                },
                                expression: "form.supplierId",
                              },
                            },
                            _vm._l(_vm.supplierOptions, function (item) {
                              return _c("el-option", {
                                key: item.value,
                                attrs: { label: item.label, value: item.value },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticStyle: { width: "320px" },
                          attrs: { label: "成本", prop: "cost" },
                        },
                        [
                          _c("el-input-number", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              min: 0,
                              precision: 2,
                              step: 0.01,
                              "controls-position": "right",
                            },
                            model: {
                              value: _vm.form.cost,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "cost", $$v)
                              },
                              expression: "form.cost",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { prop: "otherServiceTypeIds" } },
                        [
                          _c(
                            "span",
                            { attrs: { slot: "label" }, slot: "label" },
                            [
                              _vm._v("业务类型"),
                              _c("span", { staticClass: "tip" }, [
                                _vm._v("(可多选)"),
                              ]),
                            ]
                          ),
                          _c(
                            "el-checkbox-group",
                            {
                              model: {
                                value: _vm.form.otherServiceTypeIds,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "otherServiceTypeIds", $$v)
                                },
                                expression: "form.otherServiceTypeIds",
                              },
                            },
                            _vm._l(
                              _vm.otherServiceTypeOptions,
                              function (item) {
                                return _c(
                                  "el-checkbox",
                                  { key: item.id, attrs: { label: item.id } },
                                  [_vm._v(_vm._s(item.typeName))]
                                )
                              }
                            ),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "参考单号1",
                            prop: "referenceNumber",
                          },
                        },
                        [
                          _c("el-input", {
                            staticStyle: { width: "320px" },
                            attrs: { placeholder: "请输入" },
                            model: {
                              value: _vm.form.referenceNumber,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "referenceNumber", $$v)
                              },
                              expression: "form.referenceNumber",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "参考单号2",
                            prop: "referenceNumber2",
                          },
                        },
                        [
                          _c("el-input", {
                            staticStyle: { width: "320px" },
                            attrs: { placeholder: "请输入" },
                            model: {
                              value: _vm.form.referenceNumber2,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "referenceNumber2", $$v)
                              },
                              expression: "form.referenceNumber2",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "业务需求补充",
                            prop: "demandAdditional",
                          },
                        },
                        [
                          _c("el-input", {
                            staticStyle: { width: "100%" },
                            attrs: { placeholder: "请输入" },
                            model: {
                              value: _vm.form.demandAdditional,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "demandAdditional", $$v)
                              },
                              expression: "form.demandAdditional",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "备注", prop: "remark" } },
                        [
                          _c("el-input", {
                            staticStyle: { width: "100%" },
                            attrs: { placeholder: "请输入" },
                            model: {
                              value: _vm.form.remark,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "remark", $$v)
                              },
                              expression: "form.remark",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              !_vm.rowData?.id
                ? _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c("el-form-item", { attrs: { prop: "remark" } }, [
                            _c("span", [
                              _vm._v("上传附件"),
                              _c("span", { staticClass: "tip" }, [
                                _vm._v("(最多可上传2个文件)"),
                              ]),
                            ]),
                            _c(
                              "div",
                              { staticClass: "upload" },
                              [
                                _c(
                                  "el-upload",
                                  {
                                    staticClass: "upload-demo",
                                    attrs: {
                                      drag: "",
                                      action: `/api/SystemFile/uploadFile?source=12`,
                                      headers: _vm.headers,
                                      "list-type": "picture",
                                      "on-success": _vm.handleSuccess,
                                      "before-upload": _vm.beforeUpload,
                                      "show-file-list": false,
                                    },
                                  },
                                  [
                                    _c("svg-icon", {
                                      attrs: {
                                        iconClass: "upload",
                                        className: "icon",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._l(_vm.fileList, function (item, $index) {
                                  return _c(
                                    "div",
                                    { key: $index, staticClass: "fileList" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "progress" },
                                        [
                                          _c("el-progress", {
                                            attrs: {
                                              type: "circle",
                                              width: 40,
                                              height: 40,
                                              "stroke-width": 4,
                                              percentage: 100,
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c("div", { staticClass: "file" }, [
                                        _c(
                                          "p",
                                          {
                                            directives: [
                                              {
                                                name: "tooltip",
                                                rawName: "v-tooltip",
                                                value: 166,
                                                expression: "166",
                                              },
                                            ],
                                            staticClass: "fileName",
                                          },
                                          [_vm._v(_vm._s(item.fileName))]
                                        ),
                                        _c("p", { staticClass: "fileSize" }, [
                                          _vm._v(_vm._s(item.fileSize) + " KB"),
                                        ]),
                                      ]),
                                      _c("div", { staticClass: "opt" }, [
                                        _c("i", {
                                          staticClass: "el-icon-delete",
                                          attrs: { title: "删除" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.deleteFile(
                                                $index,
                                                item.id
                                              )
                                            },
                                          },
                                        }),
                                      ]),
                                    ]
                                  )
                                }),
                              ],
                              2
                            ),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "span",
        { staticClass: "footers", attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "div",
            { staticClass: "cancel flex_c_c", on: { click: _vm.cancel } },
            [_vm._v("取 消")]
          ),
          _c(
            "div",
            {
              directives: [
                {
                  name: "debounce-click",
                  rawName: "v-debounce-click",
                  value: { value: _vm.ok, args: ["form"] },
                  expression: "{ value: ok, args: ['form'] }",
                },
              ],
              staticClass: "ok flex_c_c",
            },
            [_vm._v("确 定")]
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }